module.exports = __webpack_public_path__ + "img/exhibitions.3bfa924d.svg";